// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"zN-z","smallCardRow":"AN-z","largeCardRow":"BN-z","productSearchRow":"CN-z","curatedRow":"DN-z"};